import { defined, Property, Material, Color, Event, createPropertyDescriptor } from 'cesium';

/**
 *渐变光圈纹理
 * @param {}color 颜色
 * @param {}speed 速率
 * @param {}repeatNum 重复数量
 */
function CesiumGradualLightRingMaterialProperty(options) {
    this._definitionChanged = new Event();
    this.color = options.color;
    this.speed = options.speed;
    this.repeatNum = options.repeatNum;
}
CesiumGradualLightRingMaterialProperty.prototype.getType = function() {
    return 'CesiumGradualLightRingMaterialProperty';
};
CesiumGradualLightRingMaterialProperty.prototype.getValue = function(time, result) {
    if (!defined(result)) {
        result = {};
    }
    result.color = Property.getValueOrClonedDefault(
        this.color,
        time,
        new Color(0.23, 0.67, 0.9, 1.0),
        result.color,
    );
    result.speed = Property.getValueOrClonedDefault(this.speed, time, 1, result.speed);
    result.repeatNum = Property.getValueOrClonedDefault(this.repeatNum, time, 5, result.repeatNum);
    return result;
};
CesiumGradualLightRingMaterialProperty.prototype.equals = function(other) {
    return (
        this === other ||
        (other instanceof CesiumGradualLightRingMaterialProperty &&
            Property.equals(this.color, other.color) &&
            Property.equals(this.speed, other.speed) &&
            Property.equals(this.repeatNum, other.repeatNum))
    );
};
Object.defineProperties(CesiumGradualLightRingMaterialProperty.prototype, {
    isConstant: {
        get: function() {
            return false;
        },
    },
    definitionChanged: {
        get: function() {
            return this._definitionChanged;
        },
    },
    color: createPropertyDescriptor('color'),
    speed: createPropertyDescriptor('speed'),
    repeatNum: createPropertyDescriptor('repeatNum'),
});
Material.CesiumGradualLightRingMaterialPropertyType = 'CesiumGradualLightRingMaterialProperty';
Material.CesiumGradualLightRingMaterialPropertyMaterialSource = `
float iTime= czm_frameNumber/ 100.0;
float pointy (float f) {
    // return 0.2/(abs(f)+0.2);
    return 0.01/(abs(f)+0.02);
}
czm_material czm_getMaterial(czm_materialInput materialInput)
{
    czm_material material = czm_getDefaultMaterial(materialInput);
    vec2 str = materialInput.st*1.0;
    //----------------------------------------------------------
    vec2 uv = str;
    uv.y=fract(uv.y*repeatNum);
    vec3 col001 = vec3(0.0);
    float f001 =fract( abs(uv.y - (iTime*0.5*speed)));
    col001 = vec3(pointy(f001));

    // vec3 col= vec3(0.93, 0.97, 1) -  vec3(0.7, 0.3, 0.1);//颜色2
    vec3 col= color.rgb;//颜色2
    material.diffuse =  col*(1.0-str.y)*(1.0-str.y)*(1.0-str.y)*(1.0-str.y)+col001;
    material.emission =  col+col001;
    material.alpha = (1.0-str.y);
    return material;
    }`;
Material._materialCache.addMaterial(Material.CesiumGradualLightRingMaterialPropertyType, {
    fabric: {
        type: Material.CesiumGradualLightRingMaterialPropertyType,
        uniforms: {
            color: new Color(0.23, 0.67, 0.9, 1.0),
            speed: 1,
            repeatNum: 5,
        },
        source: Material.CesiumGradualLightRingMaterialPropertyMaterialSource,
    },
    translucent: function() {
        return true;
    },
});

export default CesiumGradualLightRingMaterialProperty;
